import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
export function PendingApproval() {
    const { user, signout, refresh } = useAuth();
    const navigate = useNavigate();
    return (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-slate-50 px-4 dark:bg-slate-950", children: _jsxs("div", { className: "card w-full max-w-md p-6 text-center", children: [_jsx("h1", { className: "text-xl font-semibold", children: "Awaiting approval" }), _jsx("p", { className: "mt-3 text-slate-600 dark:text-slate-300", children: user
                        ? `Hi ${user.username}, an administrator needs to approve your account before you can sign in.`
                        : "An administrator needs to approve your account before you can sign in." }), _jsxs("div", { className: "mt-6 flex justify-center gap-2", children: [_jsx("button", { className: "btn-secondary", onClick: async () => {
                                await refresh();
                                if (user?.status === "approved")
                                    navigate("/");
                            }, children: "Check again" }), _jsx("button", { className: "btn-secondary", onClick: async () => {
                                await signout();
                                navigate("/welcome");
                            }, children: "Sign out" })] })] }) }));
}
